import * as React from "react";
import TabSet from "../../../hiberUiKit/src/molecules/TabSet/TabSet";
import Tab from "../../../hiberUiKit/src/atoms/Tab/Tab";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TabSetContent from "../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import Lead from "../../../model/lead/Lead";
import {Option} from "ts-option";
import NoteTab from "./NoteTab";
import Note from "../../../model/note/Note";
import Appointment from "../../../model/appointment/Appointment";
import AppointmentTab from "./AppointmentTab";
import {isNullOrUndefined} from "util";
import FilesTab from "./FilesTab";
import LeadReminderTab from "./LeadReminderTab";

interface IProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>;
	/**
	 * Note to edit.
	 */
	noteToEdit: Option<Note>
	/**
	 * On edit success callback.
	 */
	onNoteEditSuccess?: () => void;
	/**
	 * Appointment to edit.
	 */
	appointmentToEdit: Option<Appointment>;
	/**
	 * Appointment edit success.
	 */
	onAppointmentEditSuccess?: () => void;
	/**
	 * On tab switch callback.
	 */
	onTabsSwitch?: (tabId: LeadTab) => void;
	/**
	 * Initial tab.
	 */
	selectedTabId?: LeadTab;
	/**
	 * Partner brand Id
	 */
	partnerBrandId: Option<string>
}

export default class LeadActivityTabs extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.switchTab = this.switchTab.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<TabSet>
					<Tab icon={Icon.Note} label={"Note"} tabId={LeadTab.Note}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(LeadTab.Note)}/>
					<Tab icon={Icon.Reminder} label={"Reminder"} tabId={LeadTab.Reminder}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(LeadTab.Reminder)}/>
					<Tab icon={Icon.Appointments} label={"Appointment"} tabId={LeadTab.Appointment}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(LeadTab.Appointment)}/>
					<Tab icon={Icon.File} label={"File"} tabId={LeadTab.Files}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(LeadTab.Files)}/>
				</TabSet>
				<TabSetContent isWhite={true}>
					{this.props.lead.map(l => {
						switch (this.props.selectedTabId) {
							case LeadTab.Note:
								return <NoteTab leadId={l.id}
												noteToEdit={this.props.noteToEdit}
												onEditSuccess={this.props.onNoteEditSuccess}/>;
							case LeadTab.Reminder:
								return <LeadReminderTab leadId={l.id}
														noteToEdit={this.props.noteToEdit}
														onEditSuccess={this.props.onNoteEditSuccess}/>;
							case LeadTab.Appointment:
								return <AppointmentTab leadId={l.id}
													   leadPartnerBrandId={this.props.partnerBrandId}
													   appointmentToEdit={this.props.appointmentToEdit}
													   onAppointmentEditSuccess={this.props.onAppointmentEditSuccess}/>;
							case LeadTab.Files:
								return <FilesTab leadId={l.id}/>;
							default:
								return <NoteTab leadId={l.id}
												noteToEdit={this.props.noteToEdit}
												onEditSuccess={this.props.onNoteEditSuccess}/>;
						}
					}).orNull}
				</TabSetContent>
			</React.Fragment>
		);
	}

	switchTab(tabId: LeadTab) {
		if (!isNullOrUndefined(this.props.onTabsSwitch)) {
			this.props.onTabsSwitch(tabId);
		}
	}
}

export enum LeadTab {
	Note = "note",
	Reminder = "reminder",
	Appointment = "appointment",
	Files = "file"
}